import { useState } from "react";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api, { errMsg } from "@/lib/api";

export const APPROVAL = {
  not_required: { label: "Terus disiarkan", cls: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300" },
  pending: { label: "Menunggu admin", cls: "border-amber-500/40 bg-amber-500/10 text-amber-300" },
  approved: { label: "Diluluskan admin", cls: "border-emerald-500/40 bg-emerald-500/15 text-emerald-200" },
  rejected: { label: "Ditolak admin", cls: "border-red-500/40 bg-red-500/10 text-red-300" },
};

export function ApprovalBadge({ approval, testId }) {
  const a = APPROVAL[approval];
  if (!a) return null;
  return <Badge variant="outline" className={a.cls} data-testid={testId}>{a.label}</Badge>;
}

export async function setApproval(item, approval) {
  await api.post(`/posts/${item.post_id}/targets/${item.tid}/approval`, { approval });
  toast.success(`Status: ${APPROVAL[approval].label}`);
}

export function ApprovalSelect({ item, onChange }) {
  const [busy, setBusy] = useState(false);
  const change = async (v) => {
    setBusy(true);
    try { await setApproval(item, v); onChange?.(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Select value={item.approval || "not_required"} onValueChange={change} disabled={busy}>
      <SelectTrigger className={`h-8 w-44 text-xs ${APPROVAL[item.approval || "not_required"].cls}`} data-testid={`approval-select-${item.tid}`}><SelectValue /></SelectTrigger>
      <SelectContent>
        {Object.entries(APPROVAL).map(([k, v]) => <SelectItem key={k} value={k} data-testid={`approval-option-${k}`}>{v.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
